import React from "react";
import * as _ from 'underscore';

import { EnterHookPromises } from "../state/enterHookPromises";
import { apiPromiseHook, createEnterHookPromise } from "../../shared/flux/actions/enterHooks";
import { ActionPromises } from "../state/actionPromises";

export class Index extends React.Component {
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export const indexOnEnter = apiPromiseHook<any>(
  EnterHookPromises.allCustomerCurrencies(),
  EnterHookPromises.allRegions(),
  EnterHookPromises.allCountries(),
  createEnterHookPromise(() => ActionPromises.getContentForDropdowns())
);
